<template>
  <div class="lamp-content">
    <el-form label-postion="left" label-width="100px">
      <el-form-item label="路灯协议">
        <el-radio-group v-model="strategyItem.type">
          <el-radio :label="1">NB-IoT</el-radio>
          <el-radio :label="2">Zigbee</el-radio>
          <el-radio :label="3">LoRa</el-radio>
          <el-radio :label="4">Cat.1</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="单双灯模式">
        <el-radio-group v-model="strategyItem.is_double">
          <el-radio :label="0">单灯</el-radio>
          <el-radio :label="1">双灯</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="策略名称">
        <el-input
          placeholder="请输入策略名"
          v-model="strategyItem.title"
        ></el-input>
      </el-form-item>
      <hr />
      <el-form-item
        label="时间段"
        v-for="(item, index) in strategyItem.content"
        :key="item.key"
        :class="{
          crossed: item.crossed,
        }"
      >
        <el-row :gutter="20" class="item-list">
          <el-col :span="7">
            <el-slider
              range
              v-model="item.timeslots"
              :min="0"
              :max="86399"
              :step="900"
              @change="updateTime(item)"
              :format-tooltip="numberToTimeString"
            >
            </el-slider>
          </el-col>
          <el-col :span="4">
            <el-time-picker
              is-range
              arrow-control
              v-model="item.timeslotsObj"
              @change="updateTimeNumber(item)"
              format="HH:mm"
              style="width: 100%"
            >
            </el-time-picker>
          </el-col>
          <el-col :span="5">
            <span class="mar-r5" v-if="strategyItem.is_double">灯1亮度</span>
            <span class="mar-r5" v-else>灯亮度</span>
            <el-input-number
              v-model="item.light"
              :min="0"
              :max="100"
              class="my_number"
            ></el-input-number>
          </el-col>
          <el-col :span="5" v-if="strategyItem.is_double">
            <span class="mar-r5">灯2亮度</span>
            <el-input-number
              v-model="item.light2"
              :min="0"
              :max="100"
              class="my_number"
            ></el-input-number>
          </el-col>

          <el-col :span="2">
            <el-button class="remove" type="danger" @click="removeTime(index)"
              >删除</el-button
            >
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addTime">新建时间段</el-button>
      </el-form-item>
      <hr />
      <el-button
        type="primary"
        native-type="submit"
        @click.prevent="addStrategy"
        >保存</el-button
      >
      <el-button type="error" @click="cancel">取消</el-button>
    </el-form>
  </div>
</template>
<script>
import time from "@/utils/time";
import moment from "moment";
import strategyApi from "@/api/light/strategy";
export default {
  name: "addStrategy",
  data() {
    return {
      crossed: false,
      strategyItem: {
        title: "",
        type: 1,
        is_double: 0,
        content: [],
      },
    };
  },
  methods: {
    ...time,
    updateTimeNumber(item) {
      this.checkValid();
      item.timeslots = [
        this.timeToNumber(item.timeslotsObj[0]),
        this.timeToNumber(item.timeslotsObj[1]),
      ];
    },
    updateTime(item) {
      this.checkValid();
      item.timeslotsObj = [
        this.numberToTime(item.timeslots[0]),
        this.numberToTime(item.timeslots[1]),
      ];
    },
    removeTime(index) {
      if (confirm("确定要删除这个时间段？")) {
        this.strategyItem.content.splice(index, 1);
        this.checkValid();
      }
    },
    addStrategy() {
      let params = {
        title: this.strategyItem.title,
        is_double: this.strategyItem.is_double,
        type: this.strategyItem.type,
        time: "",
        light: "",
        light2: ""
      }
      let status = "";
      let slight = "";
      let slight2 = "";
      this.strategyItem.content
        .sort((x, y) => x.timeslotsObj[0] > y.timeslotsObj[0])
        .forEach((item, index) => {
          status +=
            [
              moment(item.timeslotsObj[0]).format("HH:mm") +
                "-" +
                moment(item.timeslotsObj[1]).format("HH:mm"),
            ] + ",";
          slight += item.light + ",";
          slight2 += item.light2 + ",";
        });
      params.time = status.substring(0, status.length - 1);
      params.light = slight.substring(0, slight.length - 1);
      if (params.time === "") {
        this.$message.error("请新建时间段");
      } else if (params.light === "") {
        this.$message.error("请设置灯亮度");
      } else {
        if (this.crossed) {
          this.$message.error("请不要选择重复时间段");
        } else {
          if(this.strategyItem.is_double){
            params.light2 = slight2.substring(0, slight2.length - 1)
          }else{
            params.light2 = params.light
          }
          strategyApi.strategyAdd(params).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("添加成功");
              this.$emit('closeMethod')
            } else {
              this.$message.error(res.data.message);
            }
          })
        }
      }
    },
    addTime() {
      this.strategyItem.content.push({
        key: Date.now(),
        light: 50,
        light2: 50,
        timeslots: [0, 3600],
        timeslotsObj: [this.numberToTime(0), this.numberToTime(3600)],
      });
      this.checkValid();
    },
    checkValid(change) {
      this.crossed = false;
      const cross = (s1, s2) => {
        return s1.timeslots[1] > s2.timeslots[0];
      };
      for (let i = 0; i < this.strategyItem.content.length; i++) {
        for (let j = i + 1; j < this.strategyItem.content.length; j++) {
          const s1 = this.strategyItem.content[i];
          const s2 = this.strategyItem.content[j];
          if (s1.timeslots[0] < s2.timeslots[0]) {
            this.crossed = cross(s1, s2);
          } else {
            this.crossed = cross(s2, s1);
          }
          if (this.crossed) {
            s1.crossed = true;
            s2.crossed = true;
            return;
          } else {
            s1.crossed = false;
            s2.crossed = false;
          }
        }
      }
    },
    cancel() {
      this.$emit('closeMethod')
    }
  }
}
</script>

<style lang='less'>
.my_number {
  width: 120px;
  .el-input__inner{
    height:28px !important;
    line-height:28px !important;
  }
}
.crossed .el-form-item__label,
.crossed .el-date-editor input,
.crossed .el-date-editor .el-input__icon {
  color: #ff4949 !important;
}
.crossed .el-slider__button,
.crossed .el-slider__bar {
  background: #ff4949 !important;
}
.crossed .el-slider__runway {
  background: #ffcdd2 !important;
}
.crossed .el-date-editor input {
  border-color: #ff4949 !important;
}
</style>